export const serviceCards = {
    assetCard: {
        entity: 'asset',
        path: 'asset',
        titleBar: { mergeParams: ['name'], new: 'service.asset.form.new.title' },
        cardTitle: {
            title: 'service.asset.form.dropdown.toggle',
            menuItems: [{ action: 'delete', label: 'service.asset.form.delete', confirm: true, modalConfig: 'assetConfirmDelete' }]
        },
        sections: [{
            id: 'asset',
            meta: { type: 'form', width: '600px' },
            groups: [
                { type: 'text', id: 'name', label: 'service.asset.form.name', placeholder: 'service.asset.form.name.placeholder', required: true },
                { type: 'text', id: 'serialNumber', label: 'service.asset.form.serialNumber', placeholder: 'service.asset.form.serialNumber.placeholder' },
                {
                    type: 'group',
                    id: 'manufacturerModel',
                    fields: [
                        { type: 'text', id: 'manufacturer', placeholder: 'service.asset.form.manufacturer' },
                        { type: 'text', id: 'model', placeholder: 'service.asset.form.model' }
                    ]
                },
                { type: 'text', id: 'category', label: 'service.asset.form.category', placeholder: 'service.asset.form.category.placeholder' },
                {
                    type: 'connect',
                    id: 'customerId',
                    displayField: 'customerName',
                    label: 'service.asset.form.customer',
                    placeholder: 'service.asset.form.customer.placeholder',
                    modalTitle: 'service.asset.form.customer.modal.title',
                    entity: 'contact',
                    valueMap: { 'customerId': 'id', 'customerName': 'name' },
                    options: { withHeaders: false }
                },
                {
                    type: 'connect',
                    id: 'locationId',
                    displayField: 'locationName',
                    label: 'service.asset.form.location',
                    placeholder: 'service.asset.form.location.placeholder',
                    modalTitle: 'service.asset.form.location.modal.title',
                    entity: 'serviceLocation',
                    valueMap: { 'locationId': 'id', 'locationName': 'name' },
                    options: { withHeaders: false }
                },
                { type: 'date', id: 'installationDate', label: 'service.asset.form.installationDate' },
                { type: 'date', id: 'warrantyExpiration', label: 'service.asset.form.warrantyExpiration' },
                { type: 'textarea', id: 'notes', label: 'service.asset.form.notes', rows: 3 },
                {
                    type: 'select',
                    id: 'status',
                    displayField: 'statusName',
                    label: 'service.asset.form.status',
                    entity: 'activeStatus',
                    valueMap: { 'status': 'id', 'statusName': 'name' },
                    options: { withHeaders: false },
                }
            ],
            buttons: [{ type: 'submit', id: 'assetCard.asset.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'name',
                columns: [{ weight: 1, basis: '100%', elements: [{ type: 'field', value: 'name', scale: 'title' }, { type: 'field', value: 'serialNumber', scale: 'normal' }, { type: 'field', value: 'customerName', scale: 'normal' }, { type: 'field', value: 'locationName', scale: 'normal' }] }]
            }
        }]
    },

    serviceContractCard: {
        entity: 'serviceContract',
        path: 'serviceContract',
        titleBar: { mergeParams: ['number'], new: 'service.serviceContract.form.new.title' },
        cardTitle: {
            title: 'service.serviceContract.form.dropdown.toggle',
            menuItems: [{ action: 'delete', label: 'service.serviceContract.form.delete', confirm: true, modalConfig: 'serviceContractConfirmDelete' }]
        },
        sections: [{
            id: 'serviceContract',
            meta: { type: 'form', width: '700px' },
            groups: [
                { type: 'nserie', id: 'number', label: 'service.serviceContract.form.number', placeholder: 'service.serviceContract.form.number.placeholder', entity: 'serviceContract', required: true, defaultType: 'nserie' },
                {
                    type: 'connect',
                    id: 'customerId',
                    displayField: 'customerName',
                    label: 'service.serviceContract.form.customer',
                    placeholder: 'service.serviceContract.form.customer.placeholder',
                    modalTitle: 'service.serviceContract.form.customer.modal.title',
                    entity: 'contact',
                    valueMap: { 'customerId': 'id', 'customerName': 'name' },
                    options: { withHeaders: false },
                    required: true
                },
                {
                    type: 'group',
                    id: 'startEndDate',
                    fields: [
                        { type: 'date', id: 'startDate', label: 'service.serviceContract.form.startDate', required: true },
                        { type: 'date', id: 'endDate', label: 'service.serviceContract.form.endDate', required: true }
                    ]
                },
                {
                    type: 'select',
                    id: 'status',
                    displayField: 'statusName',
                    label: 'service.serviceContract.form.status',
                    entity: 'serviceContractStatus',
                    valueMap: { 'status': 'id', 'statusName': 'name' },
                    options: { withHeaders: false },
                },
                {
                    type: 'group',
                    id: 'responseResolutionTimeSla',
                    fields: [
                        { type: 'number', id: 'responseTimeSLA', label: 'service.serviceContract.form.responseTimeSLA', placeholder: 'service.serviceContract.form.responseTimeSLA.placeholder', decimals: 0, variant: 'quantity' },
                        { type: 'number', id: 'resolutionTimeSLA', label: 'service.serviceContract.form.resolutionTimeSLA', placeholder: 'service.serviceContract.form.resolutionTimeSLA.placeholder', decimals: 0, variant: 'quantity' }
                    ]
                },
                { type: 'number', id: 'includedHoursPerPeriod', label: 'service.serviceContract.form.includedHoursPerPeriod', decimals: 1, variant: 'quantity' },
                { type: 'textarea', id: 'notes', label: 'service.serviceContract.form.notes', rows: 3 }
            ],
            buttons: [{ type: 'submit', id: 'serviceContractCard.serviceContract.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'number',
                columns: [{ weight: 1, basis: '100%', elements: [{ type: 'field', value: 'customerName', scale: 'title' }, { type: 'field', value: 'statusName', scale: 'normal' }] }]
            }
        }]
    },

    serviceLocationCard: {
        entity: 'serviceLocation',
        path: 'serviceLocation',
        titleBar: { mergeParams: ['name'], new: 'service.serviceLocation.form.new.title' },
        cardTitle: {
            title: 'service.serviceLocation.form.dropdown.toggle',
            menuItems: [{ action: 'delete', label: 'service.serviceLocation.form.delete', confirm: true, modalConfig: 'serviceLocationConfirmDelete' }]
        },
        sections: [{
            id: 'serviceLocation',
            meta: { type: 'form', width: '600px' },
            groups: [
                { type: 'text', id: 'name', label: 'service.serviceLocation.form.name', placeholder: 'service.serviceLocation.form.name.placeholder', required: true },
                {
                    type: 'connect',
                    id: 'customerId',
                    displayField: 'customerName',
                    label: 'service.serviceLocation.form.customer',
                    placeholder: 'service.serviceLocation.form.customer.placeholder',
                    modalTitle: 'service.serviceLocation.form.customer.modal.title',
                    entity: 'contact',
                    valueMap: { 'customerId': 'id', 'customerName': 'name' },
                    options: { withHeaders: false }
                },
                { type: 'text', id: 'address_street', label: 'service.serviceLocation.form.street', placeholder: 'service.serviceLocation.form.street.placeholder' },
                {
                    type: 'group',
                    id: 'addressPostCodeCity',
                    fields: [
                        { type: 'text', id: 'address_postCode', placeholder: 'service.serviceLocation.form.postCode' },
                        { type: 'text', id: 'address_city', placeholder: 'service.serviceLocation.form.city' }
                    ]
                },
                { type: 'text', id: 'address_region', label: 'service.serviceLocation.form.region', placeholder: 'service.serviceLocation.form.region.placeholder' },
                { type: 'textarea', id: 'accessInstructions', label: 'service.serviceLocation.form.accessInstructions', placeholder: 'service.serviceLocation.form.accessInstructions.placeholder', rows: 3 },
                {
                    type: 'select',
                    id: 'status',
                    displayField: 'statusName',
                    label: 'service.serviceLocation.form.status',
                    entity: 'activeStatus',
                    valueMap: { 'status': 'id', 'statusName': 'name' },
                    options: { withHeaders: false },
                }
            ],
            buttons: [{ type: 'submit', id: 'serviceLocationCard.serviceLocation.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'name',
                columns: [{ weight: 1, basis: '100%', elements: [{ type: 'field', value: 'name', scale: 'title' }, { type: 'field', value: 'customerName', scale: 'normal' }, { type: 'field', value: 'address_city', scale: 'normal' }] }]
            }
        }]
    },

    servicePartsLineCard: {
        entity: 'servicePartsLine',
        path: 'serviceWorkOrder/:id/servicePartsLine',
        titleBar: { mergeParams: ['productName'], new: 'service.servicePartsLine.form.new.title' },
        sections: [{
            id: 'servicePartsLine',
            meta: { type: 'form', width: '500px' },
            groups: [
                {
                    type: 'connect',
                    id: 'productId',
                    displayField: 'productName',
                    label: 'service.servicePartsLine.form.product',
                    placeholder: 'service.servicePartsLine.form.product.placeholder',
                    modalTitle: 'service.servicePartsLine.form.product.modal.title',
                    entity: 'product',
                    valueMap: { 'productId': 'id', 'productName': 'name' },
                    options: { withHeaders: false },
                    required: true
                },
                {
                    type: 'group',
                    id: 'quantityUnitCost',
                    fields: [
                        { type: 'number', id: 'quantity', label: 'service.servicePartsLine.form.quantity', required: true, decimals: 2, variant: 'quantity' },
                        { type: 'number', id: 'unitCost', label: 'service.servicePartsLine.form.unitCost', decimals: 2, variant: 'price' }
                    ]
                },
                { type: 'textarea', id: 'notes', label: 'service.servicePartsLine.form.notes', rows: 2 }
            ],
            buttons: [
                { type: 'button', id: 'servicePartsLineCard.servicePartsLine.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                { type: 'button', id: 'servicePartsLineCard.servicePartsLine.save', action: 'save', label: 'all.form.button.save', variant: 'primary' }
            ],
            displaySection: {
                emptyField: 'productName',
                columns: [{ weight: 1, basis: '100%', elements: [{ type: 'field', value: 'productName', scale: 'title' }, { type: 'field', value: 'quantity', scale: 'normal' }] }]
            }
        }]
    },

    serviceSettingsCard: {
        entity: 'serviceSettings',
        path: 'serviceSettings',
        titleBar: { label: 'service.settings.heading', mergeParams: ['settingType'], new: 'service.settings.title' },
        width: '756px',
        afterSubmit: { stay: true },
        sections: [{
            id: 'serviceSettings.shifts',
            meta: { type: 'form', width: '756px' },
            groups: [
                { type: 'description', id: 'defaultShift', label: 'service.settings.shifts.title', text: 'service.settings.shifts.description' },
                { type: 'separator', id: 'separator' },
                {
                    type: 'connect',
                    id: 'defaultShiftId',
                    displayField: 'defaultShiftName',
                    label: 'service.settings.defaultShift',
                    placeholder: 'service.settings.defaultShift.placeholder',
                    modalTitle: 'service.settings.defaultShift.modal.title',
                    entity: 'shift',
                    valueMap: { 'defaultShiftId': 'id', 'defaultShiftName': 'name', 'defaultShiftCode': 'code' },
                    options: { withHeaders: true }
                }
            ],
            buttons: [{ type: 'submit', id: 'serviceSettingsCard.shifts.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'defaultShiftId',
                emptyMessage: 'service.settings.shifts.display.title',
                columns: [
                    { weight: 3, basis: '30%', elements: [{ type: 'text', value: 'service.settings.shifts.display.title', scale: 'title' }] },
                    {
                        weight: 7,
                        basis: '70%',
                        align: 'end',
                        elements: [
                            { type: 'text', value: 'service.settings.defaultShift', scale: 'title' },
                            { type: 'merge', value: '${1}', mergeParams: ['defaultShiftName'], scale: 'normal' }
                        ]
                    }
                ]
            }
        },
        // The module's number series (37.03) — see salesSettingsCard.
        {
            id: 'serviceSettings.numberSeries',
            meta: {
                type: 'lines',
                linesArray: 'numberSeries',
                showAddLine: false,
                sectionTitle: 'settings.numberSeries.title',
                width: '756px'
            },
            groups: [
                { type: 'text-readOnly', id: 'format', label: 'settings.numberSeries.format' },
                { type: 'text-readOnly', id: 'lastValue', label: 'settings.numberSeries.lastValue' },
                { type: 'nserie', id: 'nextValue', label: 'settings.numberSeries.nextValue', placeholder: 'settings.numberSeries.nextValue.placeholder', required: true }
            ],
            buttons: [{ type: 'submit', id: 'serviceSettingsCard.numberSeries.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'nextValue',
                emptyMessage: 'settings.numberSeries.empty',
                columns: [
                    {
                        weight: 6, basis: '60%',
                        elements: [
                            { type: 'merge', value: '${1}', mergeParams: [{ type: 'translate', value: 'labelKey' }], scale: 'title' },
                            { type: 'field', value: 'format', scale: 'normal' }
                        ]
                    },
                    {
                        weight: 4, basis: '40%', align: 'end',
                        elements: [
                            { type: 'field', value: 'nextValue', scale: 'title', prefix: 'settings.numberSeries.next.prefix' },
                            { type: 'field', value: 'lastValue', scale: 'normal', prefix: 'settings.numberSeries.last.prefix', condition: { field: 'lastValue', operator: 'notEmpty' } }
                        ]
                    }
                ]
            }
        }]
    },

    serviceSkillCard: {
        entity: 'serviceSkill',
        path: 'serviceSkill',
        titleBar: { mergeParams: ['name'], new: 'service.serviceSkill.form.new.title' },
        cardTitle: {
            title: 'service.serviceSkill.form.dropdown.toggle',
            menuItems: [{ action: 'delete', label: 'service.serviceSkill.form.delete', confirm: true, modalConfig: 'serviceSkillConfirmDelete' }]
        },
        sections: [{
            id: 'serviceSkill',
            meta: { type: 'form', width: '500px' },
            groups: [
                {
                    type: 'group',
                    id: 'nameCode',
                    fields: [
                        { type: 'text', id: 'name', label: 'service.serviceSkill.form.name', placeholder: 'service.serviceSkill.form.name.placeholder', required: true },
                        { type: 'text', id: 'code', label: 'service.serviceSkill.form.code', placeholder: 'service.serviceSkill.form.code.placeholder' }
                    ]
                },
                { type: 'textarea', id: 'description', label: 'service.serviceSkill.form.description', rows: 3 }
            ],
            buttons: [{ type: 'submit', id: 'serviceSkillCard.serviceSkill.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'name',
                columns: [{
                    weight: 1,
                    basis: '100%',
                    elements: [
                        { type: 'field', value: 'name', scale: 'title' },
                        { type: 'field', value: 'code', scale: 'normal' }
                    ]
                }]
            }
        }]
    },

    serviceTechnicianCard: {
        entity: 'serviceTechnician',
        path: 'serviceTechnician',
        titleBar: { mergeParams: ['employeeName'], new: 'service.serviceTechnician.form.new.title' },
        cardTitle: {
            title: 'service.serviceTechnician.form.dropdown.toggle',
            menuItems: [{ action: 'delete', label: 'service.serviceTechnician.form.delete', confirm: true, modalConfig: 'serviceTechnicianConfirmDelete' }]
        },
        sections: [{
            id: 'serviceTechnician',
            meta: { type: 'form', width: '560px' },
            groups: [
                {
                    type: 'connect',
                    id: 'employeeId',
                    displayField: 'employeeName',
                    label: 'service.serviceTechnician.form.employee',
                    placeholder: 'service.serviceTechnician.form.employee.placeholder',
                    modalTitle: 'service.serviceTechnician.form.employee.modal.title',
                    entity: 'employee',
                    valueMap: { 'employeeId': 'id', 'employeeName': 'name' },
                    options: { withHeaders: false },
                    required: true
                },
                {
                    type: 'connect',
                    id: 'serviceSkillId',
                    displayField: 'serviceSkillName',
                    label: 'service.serviceTechnician.form.serviceSkill',
                    placeholder: 'service.serviceTechnician.form.serviceSkill.placeholder',
                    modalTitle: 'service.serviceTechnician.form.serviceSkill.modal.title',
                    entity: 'serviceSkill',
                    valueMap: { 'serviceSkillId': 'id', 'serviceSkillName': 'name' },
                    options: { withHeaders: false }
                },
                {
                    type: 'connect',
                    id: 'shiftId',
                    displayField: 'shiftCode',
                    label: 'service.serviceTechnician.form.shift',
                    placeholder: 'service.serviceTechnician.form.shift.placeholder',
                    modalTitle: 'service.serviceTechnician.form.shift.modal.title',
                    entity: 'shift',
                    valueMap: { 'shiftId': 'id', 'shiftCode': 'code', 'shiftName': 'name' },
                    options: { withHeaders: false }
                },
                { type: 'textarea', id: 'notes', label: 'service.serviceTechnician.form.notes', rows: 3 }
            ],
            buttons: [{ type: 'submit', id: 'serviceTechnicianCard.serviceTechnician.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'employeeName',
                columns: [{
                    weight: 1,
                    basis: '100%',
                    elements: [
                        { type: 'field', value: 'employeeName', scale: 'title' },
                        { type: 'field', value: 'serviceSkillName', scale: 'normal' },
                        { type: 'field', value: 'shiftCode', scale: 'normal' }
                    ]
                }]
            }
        }]
    },

    serviceTicketCard: {
        entity: 'serviceTicket',
        path: 'serviceTicket',
        titleBar: { mergeParams: ['title'], new: 'service.serviceTicket.form.new.title' },
        cardTitle: {
            title: 'service.serviceTicket.form.dropdown.toggle',
            menuItems: [{ action: 'delete', label: 'service.serviceTicket.form.delete', confirm: true, modalConfig: 'serviceTicketConfirmDelete' }]
        },
        sections: [{
            id: 'serviceTicket',
            meta: { type: 'form', width: '800px' },
            groups: [
                { type: 'nserie', id: 'number', label: 'service.serviceTicket.form.number', placeholder: 'service.serviceTicket.form.number.placeholder', entity: 'serviceTicket', required: true, defaultType: 'nserie' },
                { type: 'text', id: 'title', label: 'service.serviceTicket.form.title', placeholder: 'service.serviceTicket.form.title.placeholder', required: true },
                { type: 'richtext', id: 'description', label: 'service.serviceTicket.form.description', placeholder: 'service.serviceTicket.form.description.placeholder', resizable: true },
                {
                    type: 'group',
                    id: 'customerLocationId',
                    fields: [
                        {
                            type: 'connect',
                            id: 'customerId',
                            displayField: 'customerName',
                            label: 'service.serviceTicket.form.customer',
                            placeholder: 'service.serviceTicket.form.customer.placeholder',
                            modalTitle: 'service.serviceTicket.form.customer.modal.title',
                            entity: 'contact',
                            valueMap: { 'customerId': 'id', 'customerName': 'name' },
                            options: { withHeaders: false },
                            required: true
                        },
                        {
                            type: 'connect',
                            id: 'locationId',
                            displayField: 'locationName',
                            label: 'service.serviceTicket.form.location',
                            placeholder: 'service.serviceTicket.form.location.placeholder',
                            modalTitle: 'service.serviceTicket.form.location.modal.title',
                            entity: 'serviceLocation',
                            valueMap: { 'locationId': 'id', 'locationName': 'name' },
                            options: { withHeaders: false }
                        }
                    ]
                },
                {
                    type: 'group',
                    id: 'serviceTypeAssetId',
                    fields: [
                        {
                            type: 'connect',
                            id: 'serviceTypeId',
                            displayField: 'serviceTypeName',
                            label: 'service.serviceTicket.form.serviceType',
                            placeholder: 'service.serviceTicket.form.serviceType.placeholder',
                            modalTitle: 'service.serviceTicket.form.serviceType.modal.title',
                            entity: 'serviceType',
                            valueMap: { 'serviceTypeId': 'id', 'serviceTypeName': 'name' },
                            options: { withHeaders: false }
                        },
                        {
                            type: 'connect',
                            id: 'assetId',
                            displayField: 'assetName',
                            label: 'service.serviceTicket.form.asset',
                            placeholder: 'service.serviceTicket.form.asset.placeholder',
                            modalTitle: 'service.serviceTicket.form.asset.modal.title',
                            entity: 'asset',
                            valueMap: { 'assetId': 'id', 'assetName': 'name', 'locationId': 'locationId', 'locationName': 'locationName' },
                            options: { withHeaders: false }
                        }
                    ]
                },
                {
                    type: 'group',
                    id: 'priorityStatus',
                    fields: [
                        {
                            type: 'select',
                            id: 'priority',
                            displayField: 'priorityName',
                            label: 'service.serviceTicket.form.priority',
                            entity: 'servicePriority',
                            valueMap: { 'priority': 'id', 'priorityName': 'name' },
                            options: { withHeaders: false },
                        },
                        {
                            type: 'select',
                            id: 'status',
                            displayField: 'statusName',
                            label: 'service.serviceTicket.form.status',
                            entity: 'serviceTicketStatus',
                            valueMap: { 'status': 'id', 'statusName': 'name' },
                            options: { withHeaders: false },
                        }
                    ]
                },
                {
                    type: 'connect',
                    id: 'contractId',
                    displayField: 'contractNumber',
                    label: 'service.serviceTicket.form.contract',
                    placeholder: 'service.serviceTicket.form.contract.placeholder',
                    modalTitle: 'service.serviceTicket.form.contract.modal.title',
                    entity: 'serviceContract',
                    valueMap: { 'contractId': 'id', 'contractNumber': 'number' },
                    options: { withHeaders: false }
                }
            ],
            buttons: [{ type: 'submit', id: 'serviceTicketCard.serviceTicket.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'title',
                columns: [
                    { weight: 2, basis: '40%', elements: [{ type: 'field', value: 'number', scale: 'title' }, { type: 'field', value: 'title', scale: 'normal' }, { type: 'field', value: 'customerName', scale: 'normal' }, { type: 'field', value: 'statusName', scale: 'normal' }] },
                    { weight: 4, basis: '60%', elements: [{ type: 'richtext', value: 'description', maxLines: 6 }] }
                ]
            }
        }]
    },

    serviceTypeCard: {
        entity: 'serviceType',
        path: 'serviceType',
        titleBar: { mergeParams: ['name'], new: 'service.serviceType.form.new.title' },
        cardTitle: {
            title: 'service.serviceType.form.dropdown.toggle',
            menuItems: [{ action: 'delete', label: 'service.serviceType.form.delete', confirm: true, modalConfig: 'serviceTypeConfirmDelete' }]
        },
        sections: [{
            id: 'serviceType',
            meta: { type: 'form', width: '500px' },
            groups: [
                { type: 'text', id: 'name', label: 'service.serviceType.form.name', placeholder: 'service.serviceType.form.name.placeholder', required: true },
                { type: 'text', id: 'code', label: 'service.serviceType.form.code', placeholder: 'service.serviceType.form.code.placeholder' },
                {
                    type: 'select',
                    id: 'category',
                    displayField: 'categoryName',
                    label: 'service.serviceType.form.category',
                    entity: 'serviceCategory',
                    valueMap: { 'category': 'id', 'categoryName': 'name' },
                    options: { withHeaders: false },
                },
                { type: 'number', id: 'estimatedDuration', label: 'service.serviceType.form.estimatedDuration', decimals: 0, defaultType: 'value', defaultValue: 60, variant: 'quantity' },
                {
                    type: 'select',
                    id: 'defaultPriority',
                    displayField: 'defaultPriorityName',
                    label: 'service.serviceType.form.defaultPriority',
                    entity: 'servicePriority',
                    valueMap: { 'defaultPriority': 'id', 'defaultPriorityName': 'name' },
                    options: { withHeaders: false },
                },
                { type: 'textarea', id: 'description', label: 'service.serviceType.form.description', rows: 3 }
            ],
            buttons: [{ type: 'submit', id: 'serviceTypeCard.serviceType.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'name',
                columns: [{ weight: 1, basis: '100%', elements: [{ type: 'field', value: 'name', scale: 'title' }, { type: 'field', value: 'code', scale: 'normal' }, { type: 'field', value: 'categoryName', scale: 'normal' }] }]
            }
        }]
    },

    serviceWorkerCard: {
        entity: 'employee',
        path: 'employee',
        titleBar: { mergeParams: ['name'] },
        cardTitle: {
            title: 'employee.form.dropdown.toggle',
            buttons: []
        },
        sections: [{
            id: 'serviceWorker',
            meta: { type: 'form', width: '480px' },
            groups: [
                { type: 'text-readOnly', id: 'name', label: 'employee.list.table.displayName' },
                { type: 'text-readOnly', id: 'title', label: 'employee.list.table.title' },
                { type: 'text-readOnly', id: 'department', label: 'employee.list.table.department' }
            ],
            buttons: [],
            displaySection: {
                emptyField: 'name',
                columns: [{
                    weight: 1,
                    basis: '100%',
                    elements: [
                        { type: 'field', value: 'name', scale: 'title' },
                        { type: 'field', value: 'title', scale: 'normal' },
                        { type: 'field', value: 'department', scale: 'normal' }
                    ]
                }]
            }
        }]
    },

    serviceWorkOrderCard: {
        entity: 'serviceWorkOrder',
        path: 'serviceWorkOrder',
        titleBar: { mergeParams: ['number'], new: 'service.serviceWorkOrder.form.new.title' },
        cardTitle: {
            title: 'service.serviceWorkOrder.form.dropdown.toggle',
            menuItems: [{ action: 'delete', label: 'service.serviceWorkOrder.form.delete', confirm: true, modalConfig: 'serviceWorkOrderConfirmDelete' }]
        },
        sections: [{
            id: 'serviceWorkOrder',
            meta: { type: 'form', width: '800px' },
            groups: [
                {
                    type: 'group',
                    id: 'numberTicketId',
                    fields: [
                        { type: 'nserie', id: 'number', label: 'service.serviceWorkOrder.form.number', placeholder: 'service.serviceWorkOrder.form.number.placeholder', entity: 'serviceWorkOrder', required: true, defaultType: 'nserie' },
                        {
                            type: 'connect',
                            id: 'ticketId',
                            displayField: 'ticketNumber',
                            label: 'service.serviceWorkOrder.form.ticket',
                            placeholder: 'service.serviceWorkOrder.form.ticket.placeholder',
                            modalTitle: 'service.serviceWorkOrder.form.ticket.modal.title',
                            entity: 'serviceTicket',
                            valueMap: { 'ticketId': 'id', 'ticketNumber': 'number', 'customerId': 'customerId', 'customerName': 'customerName' },
                            options: { withHeaders: false },
                            listDisplay: { text: '${1} — ${2}', params: ['number', 'title'] }
                        }
                    ]
                },
                { type: 'text', id: 'title', label: 'service.serviceWorkOrder.form.title', placeholder: 'service.serviceWorkOrder.form.title.placeholder', required: true },
                { type: 'textarea', id: 'notes', label: 'service.serviceWorkOrder.form.notes', rows: 3 },
                {
                    type: 'group',
                    id: 'serviceTypeSkillId',
                    fields: [
                        {
                            type: 'connect',
                            id: 'serviceTypeId',
                            displayField: 'serviceTypeName',
                            label: 'service.serviceWorkOrder.form.serviceType',
                            placeholder: 'service.serviceWorkOrder.form.serviceType.placeholder',
                            modalTitle: 'service.serviceWorkOrder.form.serviceType.modal.title',
                            entity: 'serviceType',
                            valueMap: { 'serviceTypeId': 'id', 'serviceTypeName': 'name' },
                            options: { withHeaders: false }
                        },
                        {
                            type: 'connect',
                            id: 'serviceSkillId',
                            displayField: 'serviceSkillName',
                            label: 'service.serviceWorkOrder.form.serviceSkill',
                            placeholder: 'service.serviceWorkOrder.form.serviceSkill.placeholder',
                            modalTitle: 'service.serviceWorkOrder.form.serviceSkill.modal.title',
                            entity: 'serviceSkill',
                            valueMap: { 'serviceSkillId': 'id', 'serviceSkillName': 'name' },
                            options: { withHeaders: false }
                        }
                    ]
                },
                {
                    type: 'group',
                    id: 'sequenceEstimatedDuration',
                    fields: [
                        { type: 'number', id: 'sequence', label: 'service.serviceWorkOrder.form.sequence', decimals: 0, defaultType: 'value', variant: 'quantity' },
                        { type: 'number', id: 'estimatedDuration', label: 'service.serviceWorkOrder.form.estimatedDuration', decimals: 0, defaultType: 'value', variant: 'quantity' }
                    ]
                },
                {
                    type: 'connect',
                    id: 'technicianId',
                    displayField: 'technicianName',
                    label: 'service.serviceWorkOrder.form.technician',
                    placeholder: 'service.serviceWorkOrder.form.technician.placeholder',
                    modalTitle: 'service.serviceWorkOrder.form.technician.modal.title',
                    entity: 'serviceTechnician',
                    valueMap: { 'technicianId': 'id', 'technicianName': 'employeeName' },
                    options: { withHeaders: false },
                    listDisplay: 'employeeName'
                },
                {
                    type: 'group',
                    id: 'customerNameAssetId',
                    fields: [
                        { type: 'text-readOnly', id: 'customerName', label: 'service.serviceWorkOrder.form.customer' },
                        {
                            type: 'connect',
                            id: 'assetId',
                            displayField: 'assetName',
                            label: 'service.serviceWorkOrder.form.asset',
                            placeholder: 'service.serviceWorkOrder.form.asset.placeholder',
                            modalTitle: 'service.serviceWorkOrder.form.asset.modal.title',
                            entity: 'asset',
                            entityParams: { type: 'filter', filters: [{ key: 'customerId', value: '${customerId}' }] },
                            valueMap: { 'assetId': 'id', 'assetName': 'name', 'locationId': 'locationId', 'locationName': 'locationName' },
                            options: { withHeaders: false },
                            linkedFields: ['customerId']
                        }
                    ]
                },
                {
                    type: 'connect',
                    id: 'locationId',
                    displayField: 'locationName',
                    label: 'service.serviceWorkOrder.form.location',
                    placeholder: 'service.serviceWorkOrder.form.location.placeholder',
                    modalTitle: 'service.serviceWorkOrder.form.location.modal.title',
                    entity: 'serviceLocation',
                    valueMap: { 'locationId': 'id', 'locationName': 'name' },
                    options: { withHeaders: false }
                },
                {
                    type: 'select',
                    id: 'status',
                    displayField: 'statusName',
                    label: 'service.serviceWorkOrder.form.status',
                    entity: 'serviceWorkOrderStatus',
                    valueMap: { 'status': 'id', 'statusName': 'name' },
                    options: { withHeaders: false },
                },
                { type: 'separator', id: 'separator' },
                {
                    type: 'group',
                    id: 'scheduledStartEnd',
                    fields: [
                        { type: 'datetime', id: 'scheduledStart', label: 'service.serviceWorkOrder.form.scheduledStart', readOnly: true },
                        { type: 'datetime', id: 'scheduledEnd', label: 'service.serviceWorkOrder.form.scheduledEnd', readOnly: true }
                    ]
                },
                {
                    type: 'group',
                    id: 'actualStartEnd',
                    fields: [
                        { type: 'datetime', id: 'actualStart', label: 'service.serviceWorkOrder.form.actualStart' },
                        { type: 'datetime', id: 'actualEnd', label: 'service.serviceWorkOrder.form.actualEnd' }
                    ]
                }
            ],
            buttons: [{ type: 'submit', id: 'serviceWorkOrderCard.serviceWorkOrder.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }],
            displaySection: {
                emptyField: 'number',
                columns: [
                    { weight: 2, basis: '60%', elements: [{ type: 'field', value: 'number', scale: 'title' }, { type: 'field', value: 'customerName', scale: 'normal' }, { type: 'merge', value: '${1}  ·  ${2}', mergeParams: ['assetName', 'locationName'], scale: 'normal' }, { type: 'field', value: 'statusName', scale: 'normal' }] },
                    { weight: 1, basis: '40%', elements: [{ type: 'field', value: 'title', scale: 'title' }, { type: 'field', value: 'notes', scale: 'normal' }] }
                ]
            }
        }]
    },

    timeEntryCard: {
        entity: 'timeEntry',
        path: 'serviceWorkOrder/:id/timeEntry',
        titleBar: { mergeParams: ['employeeName'], new: 'service.timeEntry.form.new.title' },
        sections: [{
            id: 'timeEntry',
            meta: { type: 'form', width: '500px' },
            groups: [
                {
                    type: 'connect',
                    id: 'employeeId',
                    displayField: 'employeeName',
                    label: 'service.timeEntry.form.employee',
                    placeholder: 'service.timeEntry.form.employee.placeholder',
                    modalTitle: 'service.timeEntry.form.employee.modal.title',
                    entity: 'employee',
                    valueMap: { 'employeeId': 'id', 'employeeName': 'name' },
                    options: { withHeaders: false },
                    required: true
                },
                {
                    type: 'group',
                    id: 'startEndTime',
                    fields: [
                        { type: 'date', id: 'startTime', label: 'service.timeEntry.form.startTime', required: true },
                        { type: 'date', id: 'endTime', label: 'service.timeEntry.form.endTime' }
                    ]
                },
                { type: 'number', id: 'durationMinutes', label: 'service.timeEntry.form.durationMinutes', required: true, decimals: 0, variant: 'quantity' },
                { type: 'textarea', id: 'notes', label: 'service.timeEntry.form.notes', rows: 2 }
            ],
            buttons: [
                { type: 'button', id: 'timeEntryCard.timeEntry.delete', action: 'delete', label: 'all.form.button.delete', icon: 'delete', variant: 'danger', size: 'icon' },
                { type: 'button', id: 'timeEntryCard.timeEntry.save', action: 'save', label: 'all.form.button.save', variant: 'primary' }
            ],
            displaySection: {
                emptyField: 'employeeName',
                columns: [{ weight: 1, basis: '100%', elements: [{ type: 'field', value: 'employeeName', scale: 'title' }, { type: 'field', value: 'durationMinutes', scale: 'normal' }] }]
            }
        }]
    },
}
